export { default } from './BranchKpisStore';



// WEBPACK FOOTER //
// ./src/stores/BranchKpisStore/index.ts